import { makeStyles } from 'lib/components';

export default makeStyles((theme) => {
  const chipColors = [
    {
      background: theme.evPalette.ocean[200],
      color: theme.evPalette.ocean[800],
    },
    {
      background: theme.evPalette.charcoal[100],
      color: theme.evPalette.charcoal[900],
    },
    {
      background: theme.evPalette.charcoal[100],
      color: theme.evPalette.charcoal[900],
    },
    {
      background: theme.evPalette.charcoal[100],
      color: theme.evPalette.charcoal[900],
    },
  ];

  return ({
    mapContainer: {
      position: 'relative',
      display: 'flex',
      minHeight: '300px',
      height: '500px',
      width: '100%',
      '@media (max-width: 640px)': {
        height: '321px',
        width: '100%',
      },
    },
    propertyDetailsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      flex: 1,
    },
    propertyTypeHeading: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[800],
      '& >.myev-MuiFormLabel-asterisk': {
        color: theme.evPalette.rose[900],
      },
    },
    propertyType: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '16px',
    },
    buildingDetails: {
      padding: '8px',
      columnGap: '8px',
      rowGap: '16px',
      '&.focused': {
        backgroundColor: theme.evPalette.ocean[700],
        '& p': { color: `${theme.evPalette.salt[100]} !important` },
        borderRadius: '4px',
        border: 'none',
      },
    },
    buildingIdChip: {
      ...chipColors.reduce((styles, currStyle, index) => ({ ...styles, [`&.index-${index}`]: currStyle }), {}),
      borderRadius: '12px',
      alignItems: 'center',
      height: '18px',
      padding: '2px 8px',
      minWidth: '23px',
      margin: '0 6px',
      '& >span': { padding: 0 },
    },
  });
});
